import React from 'react';
import { useTheme } from '../theme/ThemeContext';
import { getUnlockCost } from '../game/mechanics/penalty';

interface RewardInfoModalProps {
  rewardPoints: number;
  failureCount: number;
  onClose: () => void;
}

export const RewardInfoModal: React.FC<RewardInfoModalProps> = ({
  rewardPoints,
  failureCount,
  onClose,
}) => {
  const { theme } = useTheme();
  const currentUnlockCost = getUnlockCost(failureCount);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
        padding: '24px',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '360px',
          backgroundColor: theme.isDark ? '#18181b' : '#ffffff',
          borderRadius: '24px',
          padding: '28px',
          border: `1px solid ${theme.isDark ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.1)'}`,
          boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
          color: theme.textColor,
          fontFamily: '"Outfit", sans-serif',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: '48px', marginBottom: '12px' }}>⭐</div>

        <h2 style={{ margin: '0 0 8px 0', fontSize: '22px', fontWeight: 800 }}>
          Reward Points: {rewardPoints}
        </h2>

        <p style={{ margin: '0 0 20px 0', opacity: 0.8, fontSize: '14px', lineHeight: 1.5 }}>
          Earn <strong>1 reward point</strong> for every 10×10 box you successfully complete.
        </p>

        <div
          style={{
            backgroundColor: theme.isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)',
            borderRadius: '16px',
            padding: '16px',
            marginBottom: '24px',
            textAlign: 'left',
            fontSize: '14px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <div style={{ fontWeight: 700, opacity: 0.9 }}>Busted Box Unlock Cost:</div>
          <div style={{ color: '#eab308', fontWeight: 700, fontSize: '16px' }}>
            Next Unlock: ⭐ {currentUnlockCost} Points
          </div>
          <div style={{ fontSize: '12px', opacity: 0.6 }}>
            Cost sequence: 1 → 2 → 5 → 10 → 20 → 50 → 100 max.
          </div>
        </div>

        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '14px',
            borderRadius: '12px',
            backgroundColor: '#3b82f6',
            border: 'none',
            color: '#ffffff',
            fontFamily: '"Outfit", sans-serif',
            fontWeight: 700,
            fontSize: '15px',
            cursor: 'pointer',
          }}
        >
          Got It
        </button>
      </div>
    </div>
  );
};
